import { render, staticRenderFns } from "./EmployeeChallans.vue?vue&type=template&id=474b4d21&scoped=true"
import script from "./EmployeeChallans.vue?vue&type=script&lang=js"
export * from "./EmployeeChallans.vue?vue&type=script&lang=js"
import style0 from "./EmployeeChallans.vue?vue&type=style&index=0&id=474b4d21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474b4d21",
  null
  
)

export default component.exports